/**
 * jobcrawls wiring for inspector mode. Computes `available` from the app's auth
 * (reviewer allowlist / translation_reviewer role) and a kill switch, then
 * mounts the generic InspectorProvider + the in-place overlay once at the app
 * root (LayoutDefault). Non-reviewers get `available={false}`, so the overlay
 * renders nothing and the toggle never appears — even if the flag is forced.
 *
 * Kill switch: set VITE_I18N_INSPECTOR_DISABLED=1 to disable instantly.
 */
import React from 'react';
import { useAuthOptional } from '../../contexts/AuthContext';
import { backofficeAuthAdapter } from './backoffice-auth';
import { InspectorProvider } from '../client/inspector';
import { InspectorOverlay } from '../client/InspectorOverlay';

const KILLED =
  (import.meta as { env?: Record<string, string | undefined> }).env?.VITE_I18N_INSPECTOR_DISABLED ===
  '1';

export function InspectorMount({ children }: { children: React.ReactNode }): React.ReactElement {
  const auth = useAuthOptional();
  const available =
    !KILLED && backofficeAuthAdapter.canReview(auth?.user ? { email: auth.user.email } : null);
  return (
    <InspectorProvider available={available}>
      {children}
      <InspectorOverlay />
    </InspectorProvider>
  );
}
